import { DelegateDialogContainerProps, DelegateDialogContentContainer } from './DelegateDialogContentContainer'
import { CommonDialogProps, DialogConfig } from '@/features/dialogs/common/types'
import { Dialog, DialogContent } from '@/ui/atoms/dialog/Dialog'

export type DelegateDialogProps = CommonDialogProps & DelegateDialogContainerProps

function DelegateDialog({ open, setOpen, ...props }: DelegateDialogProps) {
  return (
    <Dialog open={open} onOpenChange={props.variant === 'standalone' ? setOpen : undefined}>
      <DialogContent showCloseButton={props.variant === 'standalone'}>
        <DelegateDialogContentContainer {...props} />
      </DialogContent>
    </Dialog>
  )
}

const dialogConfig = {
  options: {
    closeOnAccountChange: true,
  },
  element: DelegateDialog,
  name: 'DelegateDialog',
} satisfies DialogConfig<DelegateDialogProps>

export const delegateDialogConfig: DialogConfig<Extract<DelegateDialogProps, { variant: 'standalone' }>> = dialogConfig
export const afterStakeDelegateDialogConfig: DialogConfig<Extract<DelegateDialogProps, { variant: 'after-stake' }>> =
  dialogConfig
